import {
    FormControl,
    FormHelperText,
    TextField,
} from "@mui/material";
import React from "react";
import { Controller } from "react-hook-form";

interface InputProps {
    name: string;
    label: string;
    control: any;
    errors?: any;
    type: string;
    initialValue?: any;
}

const InputFormControl: React.FC<InputProps> = (props) => {
    const { name, label, control, errors, type, initialValue } = props;
    return (
        <>
            {
                type === "file" ? (
                    <FormControl {...props} error={Boolean(errors[name])}>
                        <Controller
                            render={({ field: { onChange, value } }) => (
                                <TextField
                                    sx={{ width: "100%" }}
                                    error={Boolean(errors[name])}
                                    id="outlined-required"
                                    type={type}
                                    label={label}
                                    onChange={(e: any) => onChange(e.target.files)}
                                    defaultValue={value}
                                />
                            )}
                            name={name}
                            control={control}
                            defaultValue={initialValue}
                        />
                        {errors && <FormHelperText>{errors[name]?.message}</FormHelperText>}
                    </FormControl>
                )

                    : (
                        <FormControl {...props} error={Boolean(errors[name])}>
                <Controller
                    render={({ field: { onChange, value } }) => (
                        <TextField
                            sx={{ width: "100%" }}
                            error={Boolean(errors[name])}
                            id="outlined-required"
                            type={type}
                            label={label}
                            onChange={onChange}
                            defaultValue={value}
                        />
                    )}
                    name={name}
                    control={control}
                    defaultValue={initialValue}
                />
                {errors && <FormHelperText>{errors[name]?.message}</FormHelperText>}
            </FormControl>
                    )
            }
        </>
    );
};

export default InputFormControl;
